$(document).ready(() => {
	const setActiveDot = (wrapper, dotIndex) => {
		wrapper.data('active', dotIndex);
		wrapper.find('span').removeClass('active');
		wrapper
			.children()
			.eq(dotIndex - 1)
			.addClass('active');
	};

	const debounce = (func, wait) => {
		let timeout;

		return function (...args) {
			const context = this;

			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(context, args), wait);
		};
	};

	const sliderMove = (currentTarget, toRight = false) => {
		const parent = $(currentTarget).parents('.product-item--v2');
		const ul = parent.find('.product-item__image-slider ul');
		const dotsWrapper = parent.find('.product-item__slider-dots');
		let activeDot = parseInt(dotsWrapper.data('active'));

		console.log('teting');

		if (toRight) {
			ul.animate({ left: '-100%' }, 250, () => {
				ul.children().first().appendTo(ul);
				ul.css({ left: '0' });
				activeDot++;
				if (activeDot > 3) activeDot = 1;
				setActiveDot(dotsWrapper, activeDot);
			});
		} else {
			ul.children().last().prependTo(ul);
			ul.css({ left: '-100%' });
			ul.animate({ left: '0' }, 250, () => {
				activeDot--;
				if (activeDot < 1) activeDot = 3;
				setActiveDot(dotsWrapper, activeDot);
			});
		}
	};

	$(document).on('click', '.image-slider__arrow.arrow--right', (e) => {
		e.preventDefault();
		sliderMove(e.currentTarget, true);
	});

	$(document).on('click', '.image-slider__arrow.arrow--left', (e) => {
		e.preventDefault();
		sliderMove(e.currentTarget);
	});

	document.querySelectorAll('.product-item__image-slider').forEach((el) => {
		el.addEventListener(
			'swiped-left',
			debounce(() => {
				sliderMove(el, true);
			}, 50)
		);

		el.addEventListener(
			'swiped-right',
			debounce(() => {
				sliderMove(el);
			}, 50)
		);
	});

	// Top bar functionality
	$(document).on('click', '.close-top-bar', function () {
		$('.vm-sticky-top-bar').fadeOut();
		window.localStorage.setItem('sticky_no', 1);
	});

	if (window.localStorage.getItem('sticky_no') === null) {
		setTimeout(() => {
			$('.vm-sticky-top-bar').fadeIn();
		}, 5000);
	}

	// Search button functionality
	$('.main-header__search__container input[type=search]').keyup(function () {
		if ($(this).val()) {
			$('.search__container__button').show().animate({ right: '5px', opacity: '1' });
		} else {
			$('.search__container__button').hide().css({ right: '-10px', opacity: '0' });
		}
	});

	// $(document).on('click', '.main-footer__top-widgets__menu ul li a', (e) => {
	// 	e.preventDefault();
	// });

	// Functionality for the Gift Wrapping modal
	if ($('.vm-gift').length > 0) {
		$(document).on('click', '.vm-gift__open-modal', function () {
			var optionIndex = $(this).parents('.vm-gift__option').data('index');

			$('.vm-gift-modal__content').attr('class', `vm-gift-modal__content show-gift-${optionIndex}`);
			$('.vm-gift-modal').fadeIn();
		});

		$(document).on('click', '.vm-gift-modal__close', function () {
			$('.vm-gift-modal').fadeOut();
		});

		$(document).on('click', '.vm-gift-modal', function (e) {
			if (e.target.closest('.vm-gift-modal__content .modal__info') === null) {
				$('.vm-gift-modal').fadeOut();
			}
		});

		$(document).on('click', '.vm-gift__actions', async function () {
			const parent = $(this).parents('.vm-gift__option');
			const checkmark = $(this).find('.vm-gift__check.fas.fa-check');
			const cartCount = $('.cart-count');

			parent.toggleClass('selected');
			checkmark.toggleClass('checked');

			if (parent.hasClass('selected')) {
				const selectedGift = $('.vm-gift__option.selected');
				const cartCountSelector =
					'.cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count';

				if (selectedGift.length > 0) {
					const giftId = selectedGift.data('id');

					try {
						await addToCart(giftId);
					} catch (error) {
						console.error('Error adding to cart:', error);
					}

					try {
						updateCartCount(cartCountSelector);
					} catch (error) {
						console.error('Error updating cart count:', error);
					}
				}
			}
		});

		async function addToCart(giftId) {
			try {
				await $.post('/cart/add.js', {
					quantity: 1,
					id: giftId,
				});
			} catch (error) {
				console.error('Error adding to cart:', error);
				throw error;
			}
		}

		async function updateCartCount(cartCountSelector) {
			try {
				const cart = await getCartData();

				if (cartCountSelector && $(cartCountSelector).length) {
					const value = $(cartCountSelector).html() || '0';
					$(cartCountSelector)
						.html(value.replace(/[0-9]+/, cart.item_count))
						.removeClass('hidden-count');
					$('.main-header__cart__dropdown').addClass('hoverClassCart');
				}

				$.get(window.location.href, function (data) {
					$('div.main-header__cart__dropdown').html($(data).find('div.main-header__cart__dropdown').html());
					$('div.cart-count').html($(data).find('div.cart-count').html());
				});

				setTimeout(function () {
					$('.main-header__cart__dropdown').removeClass('hoverClassCart');
				}, 3000);
			} catch (error) {
				throw error;
			}
		}

		async function getCartData() {
			try {
				const response = await fetch('/cart.js');
				const data = await response.json();
				return data;
			} catch (error) {
				throw error; // Re-throw the error to be caught by the caller
			}
		}

		// $(document).on('added-to-cart', 'body', function () {
		// 	var selectedGift = $('.vm-gift__option.selected');

		// 	if (selectedGift.length > 0) {
		// 		var giftId = selectedGift.data('id');

		// 		$.post('/cart/add.js', {
		// 			quantity: 1,
		// 			id: giftId,
		// 		});
		// 	}
		// });
	}

	$(document).on('click', '.product-description__show-button', function () {
		const parent = $(this).parents('.product-description');
		const longDescription = parent.children('.product-description__expanded-description');
		const buttonText = $(this).text().trim();
		buttonText === 'Mai mult' ? $(this).text('Mai puțin') : $(this).text('Mai mult');
		longDescription.slideToggle('slow');
	});

	const urgentSaleCalculator = () => {
		const deadline = document.querySelector('.products-list').dataset.saleEnd;
		let deadlineDate = new Date(deadline);

		const urgentSaleInterval = setInterval(function () {
			const now = new Date().getTime();
			const distance = deadlineDate - now;

			if (distance > 0) {
				const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

				const hoursText = hours < 2 ? 'oră' : 'ore';
				const minutesText = minutes < 2 ? 'minut' : 'minute';

				document.querySelectorAll('.product-item__urgent-sale').forEach((item) => {
					item.classList.add('product-item__urgent-sale--visible');
					item.querySelector('span').innerText = `${hours} ${hoursText} și ${minutes} ${minutesText}`;
				});
			} else {
				clearInterval(urgentSaleInterval);
			}
		}, 1000);
	};

	if (window.location.pathname.includes('summer-sale')) {
		urgentSaleCalculator();
	}
});


